import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextFree = createSVG({
    width: 48,
    children: (jsx("path", { d: "M36.933 15.738H42V18h-7.437V6h7.351v2.263h-4.98v2.555h4.55v2.228h-4.55zm-9.107 0h5.067V18h-7.437V6h7.35v2.263h-4.98v2.555h4.551v2.228h-4.551zM21.501 18l-2.421-4.165h-1.804V18h-2.37V6h4.81c2.215 0 4 1.783 4 3.978 0 1.508-.944 2.863-2.318 3.497L24.06 18zm-4.225-9.788v3.549h2.44c.892 0 1.63-.79 1.63-1.783 0-.995-.738-1.766-1.63-1.766zm-4.096.051H8.37v2.846h4.672v2.263H8.37V18H6V6h7.18z" })),
});

export { IconTextFree };
